import { Plus, Users } from "lucide-react"
import { Button } from "@/modules/shared/ui/components/button"
import { Card, CardContent } from "@/modules/shared/ui/components/card"
import {
    Empty,
    EmptyContent,
    EmptyDescription,
    EmptyHeader,
    EmptyMedia,
    EmptyTitle,
} from "@/modules/shared/ui/components/empty"

export function EmployeesEmpty({ onAddEmployee }: { onAddEmployee: () => void }) {
    return (
        <Card className="bg-card border border-border">
            <CardContent className="p-6">
                <Empty>
                    <EmptyHeader>
                        <EmptyMedia variant="icon">
                            <Users />
                        </EmptyMedia>
                        <EmptyTitle>No employees found</EmptyTitle>
                        <EmptyDescription>
                            Try a different search or add a new employee.
                        </EmptyDescription>
                    </EmptyHeader>
                    <EmptyContent>
                        <Button 
                            variant="ghost"
                            className="w-fit pl-0 hover:text-blue-600 text-muted-foreground transition-all duration-200"
                            onClick={onAddEmployee}>
                            <Plus className="w-4 h-4" />
                            Add Employee
                        </Button>
                    </EmptyContent>
                </Empty>
            </CardContent>
        </Card>
    )
}
